// Costanti e helper condivisi dai componenti dell'Area Pulizie.

export const ymd = (d) => { const x = new Date(d); return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`; };
export const METODI = ["spazzare", "lavare", "disinfettare", "spolverare", "cambio", "sgrassare", "altro"];
export const GIORNI = [[1, "Lun"], [2, "Mar"], [3, "Mer"], [4, "Gio"], [5, "Ven"], [6, "Sab"], [7, "Dom"]];
export const DOW_ABBR = ["", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
export const FREQ = [["giornaliera", "Ogni giorno"], ["settimanale", "Settimanale (giorni)"], ["mensile", "Mensile (giorno del mese)"], ["ogni_n_giorni", "Ogni N giorni"], ["ogni_n_mesi", "Ogni N mesi"]];
export const METODO_COLOR = { spazzare: "#0891b2", lavare: "#2563eb", disinfettare: "#16a34a", spolverare: "#d97706", cambio: "#7c3aed", sgrassare: "#db2777", altro: "#64748b" };

export const capFirst = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
export const fmtGiornoLong = (iso) => { try { return capFirst(new Date(iso + "T00:00:00").toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" })); } catch { return iso; } };
export const fmtGiornoBreve = (iso) => { try { return capFirst(new Date(iso + "T00:00:00").toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long" })); } catch { return iso; } };
export function nextOccurrences(f, count = 3) {
  const base = f.data_ultima ? new Date(f.data_ultima + "T00:00:00") : new Date();
  const out = [];
  if (f.freq_tipo === "ogni_n_giorni") {
    const n = Math.max(1, Number(f.n) || 1);
    let d = new Date(base); d.setDate(d.getDate() + n);
    for (let i = 0; i < count; i++) { out.push(ymd(d)); d = new Date(d); d.setDate(d.getDate() + n); }
  } else if (f.freq_tipo === "ogni_n_mesi") {
    const n = Math.max(1, Number(f.n) || 1);
    for (let i = 1; i <= count; i++) { const d = new Date(base); d.setMonth(d.getMonth() + n * i); out.push(ymd(d)); }
  }
  return out;
}
export const meseLabel = (m) => { try { return capFirst(new Date(m + "-01T00:00:00").toLocaleDateString("it-IT", { month: "long", year: "numeric" })); } catch { return m; } };
export const last12Months = () => { const a = []; const d = new Date(); d.setDate(1); for (let i = 0; i < 12; i++) { a.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`); d.setMonth(d.getMonth() - 1); } return a; };
export const pctColor = (p, futuro) => futuro ? { bar: "bg-slate-200", text: "text-slate-400", ring: "border-slate-200" } : p >= 90 ? { bar: "bg-emerald-500", text: "text-emerald-700", ring: "border-emerald-200" } : p >= 60 ? { bar: "bg-amber-500", text: "text-amber-700", ring: "border-amber-200" } : { bar: "bg-red-500", text: "text-red-700", ring: "border-red-200" };

export function freqLabel(a) {
  if (a.freq_tipo === "giornaliera") return "Ogni giorno";
  if (a.freq_tipo === "settimanale") return "Sett.: " + (a.giorni || []).map((g) => GIORNI.find((x) => x[0] === g)?.[1]).join(" ");
  if (a.freq_tipo === "mensile") return a.giorno_mese ? `Mensile (giorno ${a.giorno_mese})` : "Mensile";
  if (a.freq_tipo === "ogni_n_giorni") return `Ogni ${a.n} giorni`;
  if (a.freq_tipo === "ogni_n_mesi") return `Ogni ${a.n} mesi`;
  return "";
}

export const groupBy = (items) => {
  const g = {};
  items.forEach((c) => {
    const gk = c.area_nome || "—"; g[gk] = g[gk] || {};
    const sk = c.stanza_nome || "__area__"; g[gk][sk] = g[gk][sk] || []; g[gk][sk].push(c);
  });
  return g;
};

export const compressToDataUrl = (file, maxDim = 900, quality = 0.65) => new Promise((res) => {
  const r = new FileReader();
  r.onload = () => {
    const img = new Image();
    img.onload = () => {
      let { width: w, height: h } = img;
      if (w > h && w > maxDim) { h = h * maxDim / w; w = maxDim; } else if (h > maxDim) { w = w * maxDim / h; h = maxDim; }
      const c = document.createElement("canvas"); c.width = w; c.height = h;
      c.getContext("2d").drawImage(img, 0, 0, w, h);
      res(c.toDataURL("image/jpeg", quality));
    };
    img.src = r.result;
  };
  r.readAsDataURL(file);
});
